import { render, staticRenderFns } from "./blog-should-you-update.vue?vue&type=template&id=45555c5a&scoped=true"
import script from "./blog-should-you-update.vue?vue&type=script&lang=js"
export * from "./blog-should-you-update.vue?vue&type=script&lang=js"
import style0 from "./blog-should-you-update.vue?vue&type=style&index=0&id=45555c5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45555c5a",
  null
  
)

export default component.exports